import { store } from '../store'
import { activePassportsByStation } from './helper'
import Platform, { PLATFORMS } from '../platforms'

const MEDIA_START = 'mediastart'
const MEDIA_STOP = 'mediastop'
class GoogleAnalytics4 {
  constructor() {
    if (!GoogleAnalytics4.instance) {
      GoogleAnalytics4.instance = this
      this.measurementId = Platform.getMeasurementId()
    }

    return GoogleAnalytics4.instance
  }

  get mediaStartEventName() {
    return MEDIA_START
  }
  get mediaStopEventName() {
    return MEDIA_STOP
  }

  _createScript() {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`
    document.body.appendChild(script)

    window.dataLayer = window.dataLayer || []

    window.gtag = function gtag() {
      window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
    window.gtag('config', this.measurementId, {
      cookie_expires: 0,
      send_page_view: false,
      ...this._avoidUndefined('user_id', store.getState().user?.pid),
    })
  }

  initializeGA4() {
    this._createScript()
    this._setUserProperties()
  }

  _avoidUndefined(key, value) {
    return (value || undefined) && { [key]: value }
  }

  async _getCommonParams() {
    let platform = await Platform.getPlatformName()
    platform =
      platform === PLATFORMS.VIZIO ? PLATFORMS.VIZIO.toUpperCase() : platform
    return {
      ...this._avoidUndefined('app_version', BUILD_NUMBER),
      ...this._avoidUndefined('pbs_platform', `GA ${platform}`),
    }
  }

  _setUserProperties() {
    let userProperties = {
      ...this._avoidUndefined('signed_in_user', store.getState().user?.pid),
      ...this._avoidUndefined(
        'passport_station',
        activePassportsByStation(store.getState().user.memberships)
      ),
      ...this._avoidUndefined(
        'station_localization',
        store.getState().station?.call_sign
      ),
    }

    window.gtag('set', 'user_properties', {
      ...userProperties,
    })
  }

  setUserProperty(property, value) {
    window.gtag('set', 'user_properties', {
      ...this._avoidUndefined(property, value),
    })
  }

  async sendMediaEvent(eventType, params = {}, screenName = '') {
    const commonParams = await this._getCommonParams()
    params = {
      ...params,
      ...commonParams,
      signed_in_status: store.getState().user.pid ? 'true' : 'false',
      ...this._avoidUndefined('screen_name', screenName),
      //todo: we should uncomment this once we have the data to populate it.
      /* ...this._avoidUndefined('screen_title', 'undefined'),
      ...this._avoidUndefined('screen_class', 'undefined'),
      ...this._avoidUndefined('content_group', 'undefined'), */
    }

    window.gtag('event', eventType, params)
  }

  async sendPageViewEvent(pageTitle) {
    const commonParams = await this._getCommonParams()
    const deviceModel = await Platform.deviceModel
    window.gtag('event', 'page_view', {
      ...commonParams,
      page_title: pageTitle,
      ...this._avoidUndefined('call_sign', store.getState().station.call_sign),
      ...this._avoidUndefined('device_model', deviceModel),
    })
  }

  async sendCustomEvent(eventType, params = {}, screenName = '') {
    const commonParams = await this._getCommonParams()
    window.gtag('event', eventType, {
      ...commonParams,
      ...params,
      ...this._avoidUndefined('screen_name', screenName),
    })
  }
}

const googleAnalytics4 = new GoogleAnalytics4()

export default googleAnalytics4
